<div [class.dark-theme]="true" class="fix-action-dialog">
	<mat-dialog-content>
		<ng-container>
			<div style="background: linear-gradient(#242424,#141414);">
			<!--	<h3 mat-dialog-title style="color: #ffffff;">{{ content.title | translate}}</h3> -->
				<h3 data-idtest="aigia-regist-dialog2-t-2Ij" mat-dialog-title style="color: #ffffff;">{{ content.title | translate}} ({{studioName}})</h3>
				<div style="margin:16px;font-size: 14px;">
					<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>
						<div fxLayout="column" style="margin-bottom:8px;">
							<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
								<mat-form-field appearance="outline" fxFlex="100" style="height: 88px;">
									<mat-label><span data-idtest="aigia-regist-dialog2-t-2St" translate>メールアドレス</span></mat-label>
									<input data-idtest="aigia-regist-dialog2-i-8Ho" #username="ngModel" (blur)="toNickname()" [(ngModel)]="content.username" autocomplete="off" email matInput maxlength="255" minlength="3" name="username" placeholder="{{'メールアドレス' | translate}}" required type="email" style="color: #ffffff">
									<mat-error *ngIf="username.errors?.['email'];"><span translate>有効なメールアドレスを入力してください</span></mat-error>
									<mat-error *ngIf="username.errors?.['required'];"><span translate>入力してください</span></mat-error>
									<mat-error *ngIf="username.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
									<mat-error *ngIf="username.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
								</mat-form-field>
							</div>

							<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
								<mat-form-field appearance="outline" fxFlex="100" style="height: 88px;">
									<mat-label><span data-idtest="aigia-regist-dialog2-t-5Ni" translate>お名前</span></mat-label>
									<input data-idtest="aigia-regist-dialog2-i-8Zr" #nickname="ngModel" [(ngModel)]="content.nickname" autocomplete="off" matInput maxlength="100" minlength="3" name="nickname" placeholder="{{'お名前' | translate}}" required type="text" style="color: #ffffff">
									<mat-hint><span data-idtest="aigia-regist-dialog2-t-1Lx" translate>3文字以上100文字まで</span></mat-hint>
									<mat-error *ngIf="nickname.errors?.['required'];"><span data-idtest="aigia-regist-dialog2-t-8Ho" translate>入力してください</span></mat-error>
									<mat-error *ngIf="nickname.errors?.['maxlength']"><span data-idtest="aigia-regist-dialog2-t-8Zr" translate>長すぎます</span></mat-error>
									<mat-error *ngIf="nickname.errors?.['minlength']"><span data-idtest="aigia-regist-dialog2-t-0Ie" translate>短すぎます</span></mat-error>
								</mat-form-field>
							</div>

							<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
								<mat-form-field appearance="outline" fxFlex="100" style="height: 88px;">
									<mat-label><span data-idtest="aigia-regist-dialog2-t-2Ko" translate>パスワード</span></mat-label>
									<input data-idtest="aigia-regist-dialog2-i-0Ie" #password="ngModel" [(ngModel)]="content.password" matInput maxlength="1000" minlength="6" name="password" placeholder="{{'パスワード' | translate}}" required type="password" style="color: #ffffff">
									<mat-hint><span data-idtest="aigia-regist-dialog2-t-4To" translate>6文字以上1000文字まで</span></mat-hint>
									<mat-error *ngIf="password.errors?.['required'];"><span translate>入力してください</span></mat-error>
									<mat-error *ngIf="password.errors?.['maxlength']"><span translate>長すぎます</span></mat-error>
									<mat-error *ngIf="password.errors?.['minlength']"><span translate>短すぎます</span></mat-error>
								</mat-form-field>
							</div>

							<div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="space-between">
								<mat-form-field appearance="outline" fxFlex="100" style="height: 88px;color: #ffffff">
									<mat-label><span data-idtest="aigia-regist-dialog2-t-6Is" translate>パスワード(確認)</span></mat-label>
									<input data-idtest="aigia-regist-dialog2-i-9Uc" #confirm_password="ngModel" [(ngModel)]="content.confirm_password" [validateEquals]="password" matInput name="confirm_password" placeholder="{{'パスワード(確認)' | translate }}" required type="password">
									<mat-hint><span data-idtest="aigia-regist-dialog2-t-0Rh" translate>6文字以上1000文字まで</span></mat-hint>
									<mat-error *ngIf="confirm_password.errors?.['required'];"><span translate>確認用パスワードを入力してください</span></mat-error>
									<mat-error *ngIf="confirm_password.errors?.['validateEquals']"><span translate>確認用パスワードが一致しません</span></mat-error>
								</mat-form-field>
							</div>

						<!--	<mat-form-field fxFlex style="margin:30px">
								<div>{{selected_studio}}</div>
								<mat-label>studio</mat-label>
								<mat-select #studio_select="ngModel" (selectionChange)="onChangeStudio($event)" [(ngModel)]="selected_studio" name="studio_select" required>
									<mat-option *ngFor="let studio of all_studios" [value]="studio">
										{{studio.nickname}}
									</mat-option>
								</mat-select>
								<mat-error *ngIf="studio_select.errors?.['required'];"><span translate>選択してください</span></mat-error>
							</mat-form-field> -->

							<div fxLayout="row" fxLayoutAlign="space-between">
								<div class="title-content" fxFlex="100">
									<mat-checkbox (change)="changeAgree($event)" [(ngModel)]="agree" name="agree" aigia-policy-button><a data-idtest="aigia-regist-dialog2-t-9Zu" translate>利用規約に同意します</a></mat-checkbox>
								</div>
							</div>

							<ng-container>
								{{completeMessage}}
							</ng-container>
						</div>
					</form>
				</div>
			</div>
		</ng-container>
	</mat-dialog-content>

	<mat-dialog-actions fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-around" fxLayoutGap="0px" fxLayoutGap.lt-sm="16px" style="padding:16px;">
		<div fxFlex="50" fxFlex.lt-sm="100" fxLayoutAlign="center">
			<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-stroked-button fxFlex="50" fxFlex.lt-sm="100"><span data-idtest="aigia-regist-dialog2-t-4Tx" translate>キャンセル</span></button>
		</div>
		<div fxFlex="50" fxFlex.lt-sm="100" fxLayoutAlign="center">
			<button (click)="onAccept()" *ngIf="!(!agree || form.invalid || isProgress)" [disabled]="!agree || form.invalid || isProgress" color="primary" mat-raised-button fxFlex="50" fxFlex.lt-sm="100"><span data-idtest="aigia-regist-dialog2-t-9Xq" translate>登録</span></button>
			<button *ngIf="(!agree || form.invalid || isProgress)" [disabled]="!agree || form.invalid || isProgress" cdkFocusInitial color="primary" mat-raised-button fxFlex="50" fxFlex.lt-sm="100"><span data-idtest="aigia-regist-dialog2-t-8Mc" translate>登録</span></button>
		</div>
	</mat-dialog-actions>
</div>
